import { AddToHomeIcon, ShareIcon } from 'icons/addHome'
import { Component, createSignal, onCleanup, onMount, Show } from 'solid-js'

import { CloseIcon } from 'icons/login'
import { addAlert } from 'store/user'
import './style/addhome.scss'

export const [showAddHome, setShowAddHome] = createSignal(false)

interface AddhomeProps {
    deferredPrompt?: any | null
    iosFallback: boolean
}

const AddHome: Component<AddhomeProps> = P => {
    const onAppInstalled = () => {
        location.reload()
    }

    onMount(() => {
        window.addEventListener('appinstalled', onAppInstalled)
    })

    onCleanup(() => {
        window.removeEventListener('appinstalled', onAppInstalled)
    })

    const close = () => setShowAddHome(false)

    return (
        <div
            classList={{ hide: !showAddHome() }}
            class='add-home'
            id='id-home-cmp'
        >
            <div class='close' onclick={close}>
                <CloseIcon />
            </div>

            <header>
                <img
                    src='/public/svgs/mascot/phone.svg'
                    alt=''
                    decoding='async'
                />
                <h1 class='title'>گوجه می‌تونه همیشه کنارت باشه!</h1>
            </header>

            <div class='details title_smaller'>
                <Show
                    when={P.iosFallback}
                    fallback={
                        <>
                            <div class='detail'>
                                <div class='icon'>
                                    <ShareIcon />
                                </div>
                                1. توی نوار پایین روی دکمه Share بزن.
                            </div>

                            <div class='detail'>
                                <div class='icon'>
                                    <AddToHomeIcon />
                                </div>
                                2. توی منوی باز شده، گزینه Add to Home Screen رو
                                انتخاب کن
                            </div>

                            <div class='detail'>
                                <div class='icon add'>Add</div>
                                3. و در آخر توی قسمت بالا روی Add بزن.
                            </div>
                        </>
                    }
                >
                    <div class='detail'>
                        <div class='icon'>
                            <ShareIcon />
                        </div>
                        1. پایین صفحه روی دکمه نصب بزن.
                    </div>

                    <div class='detail'>
                        <div class='icon'>
                            <AddToHomeIcon />
                        </div>
                        2. برنامه نصب میشه و میتونی از صفحه اصلی از گوجه استفاده
                        کنی.
                    </div>
                </Show>
            </div>

            <div class='ctas'>
                <Show
                    when={P.deferredPrompt}
                    fallback={
                        <button
                            class='basic-button got-it title_small'
                            onclick={close}
                        >
                            متوجه شدم
                        </button>
                    }
                >
                    <button
                        class='basic-button sec title_small'
                        onclick={close}
                    >
                        بعدا
                    </button>
                    <button
                        class='basic-button main title_small'
                        onclick={async () => {
                            const prompt = P.deferredPrompt
                            if (!prompt) return

                            prompt.prompt()

                            try {
                                await prompt.userChoice
                                addAlert({
                                    type: 'success',
                                    subject: 'من تو صفحه اصلی ام!',
                                    timeout: 5,
                                })
                            } catch {
                                // ignore
                            }
                        }}
                    >
                        نصب
                    </button>
                </Show>
            </div>
        </div>
    )
}
export default AddHome
